import { render, staticRenderFns } from "./SumupUnitEditTab.vue?vue&type=template&id=c95f2d54&scoped=true&"
import script from "./SumupUnitEditTab.vue?vue&type=script&lang=ts&"
export * from "./SumupUnitEditTab.vue?vue&type=script&lang=ts&"
import style0 from "./SumupUnitEditTab.vue?vue&type=style&index=0&id=c95f2d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95f2d54",
  null
  
)

export default component.exports